module.exports = "/assets/packs/images/da67dbc25de838f05ebc40a3ff5ff27d.svg";